import { StakeholderType } from '../../../../types/stakeholder.types';
import { GRANTEE, type TemplateSignatoryType } from './template-signatory-type.constant';

export const stakeholderTypeColor: Record<StakeholderType, string> = {
  [StakeholderType.ADVISOR]: '#8B5CF6',
  [StakeholderType.ANGEL]: '#F59E0B',
  [StakeholderType.BOARD_MEMBERS]: '#84CC16',
  [StakeholderType.EMPLOYEE]: '#F97316',
  [StakeholderType.FAMILY_OFFICE]: '#F43F5E',
  [StakeholderType.FOUNDER]: '#22D3EE',
  [StakeholderType.INVESTMENT_BANKS]: '#0EA5E9',
  [StakeholderType.SPV]: '#6366F1',
  [StakeholderType.OTHER_INST]: '#64748B',
  [StakeholderType.PES]: '#10B981',
  [StakeholderType.VCS]: '#D946EF',
};

export const templateSignatoryTypeColor: Record<TemplateSignatoryType, string> = {
  ...stakeholderTypeColor,
  [GRANTEE]: '#2565C8',
};
